// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2-nW9","location":"Header_location__MB7JG"};